import React, { useEffect, useState } from 'react';
import { Pane } from 'split-pane-react';
import SplitPane from 'split-pane-react';

import "split-pane-react/esm/themes/default.css"; // Import default styles
import AzureMap from '../controls/AzureMaps';
import Sidebar from './Sidebar';
import DashboardOptionDial from './DashboardOptionDial';
import { eventBus } from '../../services/event-emitter.service';



const Dashboard: React.FC = () => {
  const [sidebarIsLeft, setSidebarLeft] = useState(true);
  const [sizes, setSizes] = useState([50, 50]); // Sidebar default 50%, Map auto
  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);

  useEffect(() => {
    const handleSelectPlan = (planId: string | null) => {
      console.log('Dashboard: Received selectPlan event with ID:', planId);
      setSelectedPlanId(planId);
    };

    eventBus.on('selectPlan', handleSelectPlan);

    return () => {
      eventBus.off('selectPlan', handleSelectPlan);
    };
  }, []);

  const onChangePaneSize = (newSizes: number[]) => {
    setSizes(newSizes);
  };

  const handleSetSizes = (sizePercentages: number[]) => {
    const leftPaneSize = window.innerWidth * sizePercentages[0] / 100;
    const rightPaneSize = window.innerWidth * sizePercentages[1] / 100;
    const newSizes = [leftPaneSize, rightPaneSize];
    setSizes(newSizes);
  };

  const getPaneSize = (isLeft: boolean) => {
    return isLeft ? sizes[0] : sizes[1];
  };

  useEffect(() => {
    // const paneSize = window.innerWidth * 0.5; 
    // const newSizes = [paneSize, paneSize];
    // console.log('paneSizes', newSizes);
    // onChangePaneSize(newSizes);

    handleSetSizes([50, 50]);
  }, []);
  
  const showDashboardOptionDial= (useInSidebar: boolean) => {
    if (useInSidebar) {
      return true;  
    }

    if (!useInSidebar) {
      // Check if map is fullscreen means the other is 0
      const mapIsFull = (sidebarIsLeft && sizes[0] === 0 || !sidebarIsLeft && sizes[1] === 0);
      return mapIsFull;
    }

    return false;
  };

  return (
    <>
      <div className="full-screen">

        {/* Split Pane Layout */}
        <SplitPane
          split="vertical"
          sizes={sizes}
          onChange={onChangePaneSize}
          sashRender={() => <div className="sash"></div>}
        >
              <Pane minSize={200} maxSize='100%' className={sidebarIsLeft ? "pane-sidebar" : ""}>
                {sidebarIsLeft ? (
                  <>
                    <Sidebar
                      panelWidth={getPaneSize(true)}
                      sidebarIsLeft={sidebarIsLeft}
                      sizes={sizes}
                      onSetSizes={handleSetSizes}
                      setSidebarLeft={setSidebarLeft}
                    />
                  </>
                ) : (
                  <>
                    <AzureMap selectedPlanId={selectedPlanId} onSelectPlan={setSelectedPlanId} />
                    {showDashboardOptionDial(false) && (
                      <DashboardOptionDial
                        sidebarIsLeft={sidebarIsLeft}
                        sizes={sizes}
                        onSetSizes={handleSetSizes}
                        setSidebarLeft={setSidebarLeft} />
                    )}
                  </>
                )}
              </Pane>

              <Pane minSize={200} maxSize='100%' className={!sidebarIsLeft ? "pane-sidebar" : ""}>
                {sidebarIsLeft ? (
                  <>
                    <AzureMap selectedPlanId={selectedPlanId} onSelectPlan={setSelectedPlanId} />
                    {showDashboardOptionDial(false) && (
                      <DashboardOptionDial
                        sidebarIsLeft={sidebarIsLeft}
                        sizes={sizes}
                        onSetSizes={handleSetSizes}
                        setSidebarLeft={setSidebarLeft} />
                    )}
                  </>
                ) : (
                  <>
                    <Sidebar
                      panelWidth={getPaneSize(false)}
                      sidebarIsLeft={sidebarIsLeft}
                      sizes={sizes}
                      onSetSizes={handleSetSizes}
                      setSidebarLeft={setSidebarLeft}
                    />
                    {showDashboardOptionDial(true) && (
                      <DashboardOptionDial
                        sidebarIsLeft={sidebarIsLeft}
                        sizes={sizes}
                        onSetSizes={handleSetSizes}
                        setSidebarLeft={setSidebarLeft} />
                    )}
                  </>
                )}
              </Pane>
        </SplitPane>
      </div>
    </>
  );
};

export default Dashboard;